import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";

import ImageCard from "./ImageCard";
import { Container } from "./styled";

const ProductImageSliderCommon = ({ sliderData }) => {
  const settings = {
    dots: true,
    dotsClass: "slick-dots slick-dots-common slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Container>
      <div>
        <Slider {...settings}>
          {sliderData &&
            sliderData.map((data, index) => (
              <div key={index}>
                <ImageCard imgSrc={data.mainImgUrl} />
              </div>
            ))}
        </Slider>
      </div>
    </Container>
  );
};

ProductImageSliderCommon.propTypes = {
  sliderData: PropTypes.array,
};

export default ProductImageSliderCommon;
